import React, { useState } from "react";
import { API_URLS } from "../../../../../api/apiUrls";
import { postApi } from "../../../../../api/api_instance";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { Input } from "antd";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";

const CustomerAddNewSubSection = ({
  onOpen,
  onClose,
  sectionId,
  clientId,
  setPopupData,
  setSubSectionCreated,
}) => {
  const [subSections, setSubSections] = useState("");
  const [errors, setErrors] = useState(false);

  const handlePopupClose = () => {
    setPopupData(null);
  };

  const handleClear = () => {
    setSubSections([""]);
    setErrors(false);
    onClose();
  };

  const createSection = async (subsections, clientId, sectionId) => {
    try {
      const body = {
        customSectionId: sectionId,
        client_id: clientId,
        status: "Active",
        name: subsections,
        description: "This is description",
      };
      const response = await postApi({
        apiUrl: API_URLS.CREATE_CUSTOMER_SUBSECTION,
        headers: { client: clientId },
        data: body,
      });
      if (response.success) {
        setPopupData({
          type: "success",
          title: "Sub Section Created",
          message: "New Sub Section created",
        });
        onClose();
      } else {
        setPopupData({
          type: "warning",
          title: "Failed in Adding New Sub Section",
          message: `${response.message}`,
        });
        onClose();
      }
    } catch (error) {
      console.error("Error in creating new Sub Section", error);
      setPopupData({
        type: "error",
        title: "Creation Failed",
        message:
          error.message || "There was a problem creating the Sub section.",
      });
      onClose();
    } finally {
      setTimeout(() => {
        setPopupData(null);
      }, 2000);
    }
  };

  const handleSave = async () => {
    if (!subSections.trim()) {
      setErrors(true);
      return;
    }
    await createSection(subSections, clientId, sectionId);
  };

  return (
    <div className="flex justify-center my-4">
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Sub Sections </h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <div className="mb-4">
              <p className="text-base font-light px-2">Sub Section *</p>
              <Input
                value={subSections}
                onChange={(e) => setSubSections(e.target.value)}
                placeholder={`Enter Sub Section`}
                style={{
                  border: "1px solid #ebedf3",
                  borderRadius: "10px",
                  padding: "10px",
                }}
                className="text-base font-light"
              />
              {errors && (
                <p className="text-red-500 text-sm mt-2">
                  Please fill out this field.
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleClear}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default CustomerAddNewSubSection;
